<template>
  <div class="setComponent">
    <!-- 提示栏 -->
    <el-alert
      style="margin:15px 0;"
      :title="this.$i18n.t('wm_lang_e366cc')+'POP'+this.$i18n.t('wm_lang_674b1e')"
      :closable="false"
      type="info">
    </el-alert>
    <!-- 表单 -->
    <el-form :model="ruleForm" ref="ruleForm" label-width="0" class="form-setting" size="medium">
      <el-form-item>
        <el-button type="primary" @click="addEmailAccount">{{$t("wm_lang_html_a46aa1")}}</el-button>
        <!--<el-link>{{$t("wm_lang_html_508db5")}}POP{{$t("wm_lang_html_e9e805")}}</el-link>-->
      </el-form-item>
      <!-- 表格 -->
      <el-form-item>
      <el-table
        size="medium"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          :label="$i18n.t('wm_lang_5893fa')">
          <template slot-scope="scope">
            <p style="margin-left: 10px">{{ scope.row.popEmail }}</p>
            <p style="margin-left: 10px">{{$t("wm_lang_html_4cbc13")}}{{ scope.row.folderName }}</p>
          </template>
        </el-table-column>
        <el-table-column
          :label="$i18n.t('wm_lang_2b6bc0')"
          width="200">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="receive(scope.row.popEmail)">[{{$t("wm_lang_html_c82a9d")}}]</el-link>
            <el-link type="primary" :underline="false" @click="editAccount(scope.row.popEmail)">[{{$t("wm_lang_html_06ee96")}}]</el-link>
            <el-link type="danger" :underline="false" @click="deleteAccount(scope.row.popEmail)">[{{$t("wm_lang_html_2f4aad")}}]</el-link>
          </template>
        </el-table-column>
        <!--<el-table-column-->
          <!--prop="status"-->
          <!--label=this.$i18n.t('wm_lang_3d3057')-->
          <!--width="160">-->
          <!--<el-switch></el-switch>-->
        <!--</el-table-column>-->
      </el-table>
      </el-form-item>
    </el-form>

    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
export default {
  name: 'otherEmailAccount',
  data () {
    return {
      emailDomain: '',
      // 表格
      tableData: [],
      ruleForm: {
        //
      },
      rules: {
        //
      }
    }
  },
  mounted() {
    this.viewAccountList();
  },
  methods: {
    // 表单
    addEmailAccount() {
      this.$router.push({name: 'addEmailAccount'});
      this.$EventBus.$emit("updateBreadcrumb",{setBreadcrumb: this.$i18n.t('wm_lang_da760a')+'POP'+this.$i18n.t('wm_lang_0611d8')+'###'+this.$i18n.t('wm_lang_612c43')});
    },
    editAccount(popEmail) {
      this.$router.push({name: 'addEmailAccount', params: {popEmail: popEmail}});
      this.$EventBus.$emit("updateBreadcrumb",{setBreadcrumb: this.$i18n.t('wm_lang_da760a')+'POP'+this.$i18n.t('wm_lang_0611d8')+'###'+this.$i18n.t('wm_lang_78b124')});
    },
    deleteAccount(popEmail) {
      this.$confirm(`${this.$i18n.t('custom_lang_0081')}${popEmail}${this.$i18n.t('custom_lang_0082')}`, this.$i18n.t('wm_lang_c45357'), {
        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Pop.delMailPopInfoParamBuilder();
          pm.popEmail = popEmail;
          api.Pop.delMailPopInfo(pm, function (res) {
            if(res.data.code === 0) {
              self.$message({
                type: 'success',
                message: self.$i18n.t('wm_lang_1e86ec')
              });
              self.viewAccountList();
            } else {
              /*self.$message({
                type: 'error',
                message: this.$i18n.t('wm_lang_5c7c95')
              });*/
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }).catch(() => {
        //
      });
    },
    receive(popEmail) {
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Pop.popCollectMailParamBuilder();
        pm.popEmail = popEmail;
        api.Pop.popCollectMail(pm, function (res) {
          if(res.data.code === 0) {
            self.$message({
              type: 'success',
              message: self.$i18n.t('wm_lang_b4f3cb')+ popEmail + self.$i18n.t('wm_lang_e9e805')+'...'
            });
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    viewAccountList() {
      let self = this;
      (function (api, enums, pms) {
        api.Pop.queryMailPopInfoList({}, function (res) {
          if(res.data.code === 0) {
            self.tableData = res.data.data;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/otherEmailAccount.vue